import { render, staticRenderFns } from "./AProfesiones.vue?vue&type=template&id=6463e360"
import script from "./AProfesiones.vue?vue&type=script&lang=js"
export * from "./AProfesiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports